import React from 'react';

/**
 * Listens for a barcode scanner anywhere on the page, without an input to select
 * first. Renders nothing.
 *
 * A keyboard wedge scanner fires its characters far faster than anyone types and
 * ends with Enter, so a burst of keys inside MAX_KEY_INTERVAL that terminates in
 * Enter is treated as a scan. Anything slower is someone at the keyboard and is
 * left alone, as is any key pressed while a field has focus, so typing in a search
 * box or in the visible scanner keeps working as before.
 */
class BarcodeListener extends React.Component {

    static defaultProps = {
        onBarcode: (barcode) => {},
    };

    // Scanners emit a character every few ms, a fast typist needs 100ms or more.
    static MAX_KEY_INTERVAL = 50;
    static MIN_LENGTH = 3;

    constructor(props) {
        super(props);

        this.buffer = '';
        this.lastKeyAt = 0;
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    isTypingInField() {
        let element = document.activeElement;

        if (! element) {
            return false;
        }

        return (
            element.tagName === 'INPUT' ||
            element.tagName === 'TEXTAREA' ||
            element.tagName === 'SELECT' ||
            element.isContentEditable
        );
    }

    handleKeyDown(e) {
        if (this.isTypingInField()) {
            this.buffer = '';
            return;
        }

        let now = Date.now();
        let elapsed = now - this.lastKeyAt;

        this.lastKeyAt = now;

        if (e.key === 'Enter') {
            let barcode = this.buffer;

            this.buffer = '';

            if (barcode.length >= BarcodeListener.MIN_LENGTH) {
                this.props.onBarcode(barcode);
            }

            return;
        }

        // A gap this long means a person, so start over rather than gluing their
        // keystrokes onto whatever came before.
        if (elapsed > BarcodeListener.MAX_KEY_INTERVAL) {
            this.buffer = '';
        }

        if (e.key.length === 1) {
            this.buffer += e.key;
        }
    }

    render() {
        return null;
    }
}

export default BarcodeListener;
